import { render, staticRenderFns } from "./OlabProjectProfile.vue?vue&type=template&id=036f69dc&"
import script from "./OlabProjectProfile.vue?vue&type=script&lang=js&"
export * from "./OlabProjectProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports